import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenHarvestFetchAction from './communityGardenHarvestFetch.action.json' with { type: 'json' }
import { communityGardenHarvestObject } from '../../communityGardenHarvestObject'

const communityGardenHarvestFetchDefinition = defineAction({
  ...communityGardenHarvestFetchAction,

  input: z.object({
    id: communityGardenHarvestObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: communityGardenHarvestObject,
})

export default communityGardenHarvestFetchDefinition
